import React, { useState } from "react";

const ReadMore = ({ children, maxLength = 30 }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = (e) => {
    e.preventDefault(); // Prevent the default action
    setIsReadMore(!isReadMore);
  };

  return text ? (
    text.length <= maxLength ? (
      text
    ) : (
      <p className="text mb-0">
        {isReadMore ? text.slice(0, maxLength) : text}
        <a
          href="#"
          onClick={toggleReadMore}
          className="read-or-hide text-primary text-decoration-none"
        >
          {isReadMore ? " ..Read more" : " Show less"}
        </a>
      </p>
    )
  ) : (
    "-"
  );
};

export default ReadMore;
